/* unplugin-vue-components disabled */import script from "./Integral.vue?vue&type=script&setup=true&name=Integral&lang=js"
export * from "./Integral.vue?vue&type=script&setup=true&name=Integral&lang=js"

import "./Integral.vue?vue&type=style&index=0&id=a835dac6&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a835dac6"]])

export default __exports__